module.exports = __webpack_public_path__ + "static/media/Simple-Line-Icons.f33df365.eot";